// src/context/FuncionContext.jsx
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { funcionService } from '../services/FuncionService';
import { syncEcuadorTimeWith } from "../utils/ecuadorTime";
import { useAuth } from './AuthContext';




const FuncionContext = createContext();

export const FuncionProvider = ({ children }) => {

  const { user } = useAuth();
  const userScope = user?.local?.id || user?.estudiante_id || user?.student_id || user?.id || user?.email || 'anon';

  const [allowedContentTypes, setAllowedContentTypes] = useState([]);
  const [allStructureTypes, setAllStructureTypes] = useState([]);
  // === Nuevas estados === 
  const [studentProgress, setStudentProgress] = useState({});
  const [utmCoins, setUTMCoins] = useState(null);
  const [studentStreak, setStudentStreak] = useState(null);
  const [progressLoading, setProgressLoading] = useState(false);
  const [taskSubmissions, setTaskSubmissions] = useState({});
  const [courseStructureCache, setCourseStructureCache] = useState({});   // { [courseId]: structure[] }
  const [courseProgressMap, setCourseProgressMap] = useState({});

    const [storeItemsCache, setStoreItemsCache] = useState([]);  // �ltimo listado
    const [storePurchasesCache, setStorePurchasesCache] = useState([]); // mis compras
    const [storeLoading, setStoreLoading] = useState(false);
    const utmcoinsInflightRef = React.useRef(null);
  const streakInflightRef = React.useRef(null);
  const gamificationSummaryInflightRef = React.useRef(null);


  // === FUNCIONES EXISTENTES ===


  const toNum = (v, d = 0) => {
    const n = typeof v === 'string' ? parseFloat(v) : Number(v);
    return Number.isFinite(n) ? n : d;
  };

  // Calcula y guarda el % global del curso (promedio de los niveles)
  const computeAggregateCourseProgress = useCallback((courseId, structure, progressArrOrMap) => {
    const progressMap = Array.isArray(progressArrOrMap)
      ? progressArrOrMap.reduce((acc, p) => { acc[p.estructura_id] = p; return acc; }, {})
      : (progressArrOrMap || {});
    const levels = Array.isArray(structure) ? structure : [];
    if (!levels.length) {
      setCourseProgressMap(prev => ({ ...prev, [courseId]: 0 }));
      return 0;
    }
    const sum = levels.reduce((acc, lvl) => acc + toNum(progressMap[lvl.id]?.porcentaje_completado || 0, 0), 0);
    const avg = sum / levels.length;
    const value = Math.round(toNum(avg, 0));
    setCourseProgressMap(prev => ({ ...prev, [courseId]: value }));
    return value;
  }, []);

  // Admin: todos los cursos
  const fetchCourses = useCallback(async (params) => {
    return await funcionService.fetchCourses(params);
  }, []);

  const fetchFacultades = useCallback(async (params) => {
    return await funcionService.fetchFacultades(params);
  }, []);

  // Admin: crear facultad
  const createFacultad = useCallback(async (payload) => {
    return await funcionService.createFacultad(payload);
  }, []);

  // Admin: actualizar facultad
  const updateFacultad = useCallback(async (id, payload) => {
    return await funcionService.updateFacultad(id, payload);
  }, []);

 // Admin: eliminar facultad
  const deleteFacultad = useCallback(async (id, options) => {
    return await funcionService.deleteFacultad(id, options);
  }, []);

  // Estudiante: solo cursos inscritos
  const fetchStudentCourses = async (params) => {
    return await funcionService.fetchStudentCourses(params);
  };

  // Docente: solo cursos asignados
  const fetchTeacherCourses = async (params) => {
    return await funcionService.fetchTeacherCourses(params);
  };

  // Obtener curso específico
  const getCourse = async (id) => {
    return await funcionService.getCourse(id);
  };

  // Crear curso (admin/docente)
  const createCourse = async (courseData) => {
    return await funcionService.createCourse(courseData);
  };

  // Actualizar curso (admin/docente)
  const updateCourse = async (id, courseData) => {
    return await funcionService.updateCourse(id, courseData);
  };

  // Eliminar curso (admin)
  const deleteCourse = async (id) => {
    return await funcionService.deleteCourse(id);
  };

  // Obtener estudiantes de un curso
  const getCourseStudents = async (courseId, params) => {
    return await funcionService.getCourseStudents(courseId, params);
  };

  // Asignar docente a curso (admin)
  const assignTeacherToCourse = async (courseId, teacherData) => {
    return await funcionService.assignTeacherToCourse(courseId, teacherData);
  };

  // Obtener niveles de un curso
  const getCourseLevels = async (courseId) => {
    return await funcionService.getCourseLevels(courseId);
  };

  // === NUEVAS FUNCIONES PARA ADMIN DASHBOARD ===

  // Obtener estadísticas generales del dashboard
  const fetchDashboardStats = async () => {
    return await funcionService.fetchDashboardStats();
  };

  // Obtener todos los usuarios (admin)
  const fetchUsers = async (params) => {
    return await funcionService.fetchUsers(params);
  };

  // Obtener estadísticas de usuarios
  const fetchUserStats = async () => {
    return await funcionService.fetchUserStats();
  };

  // Obtener todos los estudiantes (admin)
  const fetchStudents = async (params) => {
    return await funcionService.fetchStudents(params);
  };

  // Obtener todos los docentes (admin)
  const fetchTeachers = async (params) => {
    return await funcionService.fetchTeachers(params);
  };

  const findUserForImport = async (params) => {
    return await funcionService.findUserForImport(params);
  };

  // Obtener estadísticas de cursos
  const fetchCourseStats = async () => {
    return await funcionService.fetchCourseStats();
  };

  // Obtener actividad reciente del sistema
  const fetchRecentActivity = async (params) => {
    return await funcionService.fetchRecentActivity(params);
  };

  // Obtener registros recientes
  const fetchRecentRegistrations = async (params) => {
    return await funcionService.fetchRecentRegistrations(params);
  };

  // Crear usuario (admin)
  const createUser = async (userData) => {
    return await funcionService.createUser(userData);
  };

  // Actualizar usuario (admin)
  const updateUser = async (id, userData) => {
    return await funcionService.updateUser(id, userData);
  };

  // Eliminar usuario (admin)
  const deleteUser = async (id) => {
    return await funcionService.deleteUser(id);
  };

  // Cambiar rol de usuario (admin)
  const changeUserRole = async (userId, roleData) => {
    return await funcionService.changeUserRole(userId, roleData);
  };

  // Activar/Desactivar usuario (admin)
  const toggleUserStatus = async (userId, status) => {
    return await funcionService.toggleUserStatus(userId, status);
  };

  // Obtener reportes del sistema
  const fetchSystemReports = async (params) => {
    return await funcionService.fetchSystemReports(params);
  };

  // Generar reporte específico
  const generateReport = async (reportType, params) => {
    return await funcionService.generateReport(reportType, params);
  };

  const addUserRole = async (userId, role) => {
    return await funcionService.addUserRole(userId, role);
  };

  // Remover rol de usuario
  const removeUserRole = async (userId, role) => {
    return await funcionService.removeUserRole(userId, role);
  };

  // Obtener usuario específico por ID
  const getUser = async (id) => {
    return await funcionService.getUser(id);
  };

  const getUserRoles = async (userId) => {
    return await funcionService.getUserRoles(userId);
  };

  // === FUNCIONES PARA GESTIÓN DE DOCENTES ===

  // Actualizar asignación de docente
  const updateTeacherAssignment = async (assignmentId, assignmentData) => {
    return await funcionService.updateTeacherAssignment(assignmentId, assignmentData);
  };

  // Remover docente de curso
  const removeTeacherFromCourse = async (assignmentId) => {
    return await funcionService.removeTeacherFromCourse(assignmentId);
  };

  // Obtener cursos de un docente específico
  const getTeacherCourses = async (teacherId, params) => {
    return await funcionService.getTeacherCourses(teacherId, params);
  };

  // === NUEVAS FUNCIONES PARA GESTIÓN DE ESTUDIANTES ===

  // Inscribir estudiante a curso
  const enrollStudentToCourse = async (courseId, studentData) => {
    return await funcionService.enrollStudentToCourse(courseId, studentData);
  };

  // Actualizar inscripción de estudiante
  const updateStudentEnrollment = async (enrollmentId, enrollmentData) => {
    return await funcionService.updateStudentEnrollment(enrollmentId, enrollmentData);
  };

  // Remover estudiante de curso
  const removeStudentFromCourse = async (enrollmentId) => {
    return await funcionService.removeStudentFromCourse(enrollmentId);
  };

  // Obtener cursos de un estudiante específico
  const getStudentCourses = async (studentId, params) => {
    return await funcionService.getStudentCourses(studentId, params);
  };

  // === NUEVAS FUNCIONES PARA GESTIÓN DE HORARIOS DE EXAMEN ===

  // Obtener horarios de examen
  const fetchExamSchedules = async (params) => {
    return await funcionService.fetchExamSchedules(params);
  };

  // Obtener estadísticas de horarios de examen
  const fetchExamStats = async () => {
    return await funcionService.fetchExamStats();
  };

  // Crear nuevo horario de examen
  const createExamSchedule = async (scheduleData) => {
    return await funcionService.createExamSchedule(scheduleData);
  };

  const fetchExamAssistantOptions = async (filters) => {
    return await funcionService.fetchExamAssistantOptions(filters);
  };

  // Actualizar horario de examen
  const updateExamSchedule = async (scheduleId, updateData) => {
    return await funcionService.updateExamSchedule(scheduleId, updateData);
  };


  // 1) Definiciones (arriba, junto a las otras):
  const fetchExams = async (params) => {
    return await funcionService.fetchExams(params);
  };
  const createExam = async (examData) => {
    return await funcionService.createExam(examData);
  };
  const updateExam = async (id, examData) => {
    return await funcionService.updateExam(id, examData);
  };
  const deleteExam = async (id) => {
    return await funcionService.deleteExam(id);
  };

  // Preguntas del examen
  const fetchExamQuestions = async (examId) => {
    return await funcionService.fetchExamQuestions(examId);
  };
  const addCustomExamQuestion = async (examId, payload) => {
    return await funcionService.addCustomExamQuestion(examId, payload);
  };
  const cloneExamQuestion = async (examId, payload) => {
    return await funcionService.cloneExamQuestion(examId, payload);
  };


  const updateExamQuestion = async (examId, questionId, payload) => {
    return await funcionService.updateExamQuestion(examId, questionId, payload);
  };
  const deleteExamQuestion = async (examId, preguntaId) => {
    return await funcionService.deleteExamQuestion(examId, preguntaId);
  };
  // Eliminar horario de examen
  const deleteExamSchedule = async (scheduleId) => {
    return await funcionService.deleteExamSchedule(scheduleId);
  };

  const browseStructureQuestions = async (params) => funcionService.browseStructureQuestions(params);
  const browseStructureMeta = async (cursoID) => funcionService.browseStructureMeta(cursoID);


  const browseGameItemQuestions = async (params) => {
    return await funcionService.browseGameItemQuestions(params);
  };
  // === FUNCIONES PARA GESTIÓN DE ESTUDIANTES EN EXÁMENES ===

  // Obtener estudiantes agendados para un horario específico
  const fetchExamStudents = async (scheduleId) => {
    return await funcionService.fetchExamStudents(scheduleId);
  };

  // Obtener estudiantes disponibles para agendar
  const fetchAvailableStudents = async (scheduleId) => {
    return await funcionService.fetchAvailableStudents(scheduleId);
  };

  // Agregar estudiante a un horario de examen
  const addStudentToExam = async (scheduleId, studentId) => {
    return await funcionService.addStudentToExam(scheduleId, studentId);
  };

  // Remover estudiante de un horario de examen
  const removeStudentFromExam = async (scheduleId, studentId) => {
    return await funcionService.removeStudentFromExam(scheduleId, studentId);
  };

  // Actualizar estado de agendamiento de un estudiante
  const updateStudentExamStatus = async (scheduleId, studentId, newStatus) => {
    return await funcionService.updateStudentExamStatus(scheduleId, studentId, newStatus);
  };

  // Cargar tipos de contenido permitidos
  const loadAllowedContentTypes = async () => {
    try {

      const result = await funcionService.getAllowedContentTypes();
      setAllowedContentTypes(result.tipos_permitidos || []);


    } catch (error) {
      console.error('❌ Error cargando tipos de contenido:', error);
      // Fallback a valores por defecto
      setAllowedContentTypes(['modulo']);
    } finally {
    }
  };

  // Cargar todos los tipos de estructura disponibles
  const loadAllStructureTypes = async () => {
    try {
      const result = await funcionService.getAllStructureTypes();
      setAllStructureTypes(result.tipos_disponibles || []);


    } catch (error) {
      console.error('❌ Error cargando tipos de estructura:', error);
    }
  };

  // Actualizar tipos de contenido permitidos
  const updateAllowedContentTypes = async (nuevos_tipos) => {
    try {
      const result = await funcionService.updateAllowedContentTypes(nuevos_tipos);

      // Actualizar el estado local inmediatamente
      setAllowedContentTypes(nuevos_tipos);


      return result;
    } catch (error) {
      console.error('❌ Error actualizando tipos de contenido:', error);
      throw error;
    } finally {

    }
  };

  // Validar configuración actual
  const validateContentTypesConfiguration = async () => {
    try {
      const result = await funcionService.validateContentTypesConfiguration();

      return result;
    } catch (error) {
      console.error('❌ Error validando configuración:', error);
      throw error;
    }
  };

  // Todos los apartados de la estructura pueden tener recursos/contenido.
  const canHaveContent = () => true;

  // Obtener información de un tipo específico
  const getStructureTypeInfo = (tipo) => {
    return allStructureTypes.find(t => t.tipo === tipo) || null;
  };

  const getSystemConfigurations = async () => {
    return await funcionService.getSystemConfigurations();
  };

  const updateSystemConfiguration = async (clave, valor) => {
    return await funcionService.updateSystemConfiguration(clave, valor);
  };

  // === Función modificada getCourseStructureStudent ===
  const getCourseStructureStudent = useCallback(async (courseId, includeProgress = true) => {
    try {
      const result = await funcionService.getCourseStructureStudent(courseId);

      // Cachear estructura para futuros recálculos
      setCourseStructureCache(prev => ({ ...prev, [courseId]: result.structure || [] }));

      // Actualizar progreso por elemento (mapa local)
      if (includeProgress && result.progress) {
        const progressMap = {};
        result.progress.forEach(p => { progressMap[p.estructura_id] = p; });
        setStudentProgress(prev => ({ ...prev, [courseId]: progressMap }));

        // Calcular y guardar progreso GLOBAL del curso
        computeAggregateCourseProgress(courseId, result.structure || [], result.progress);
      }

      return result;
    } catch (error) {
      console.error('Error obteniendo estructura:', error);
      throw error;
    }
  }, [computeAggregateCourseProgress]);

  const getCourseStructureAdminPreview = useCallback(async (courseId) => {
    return funcionService.getCourseStructureAdminPreview(courseId);
  }, []);


  useEffect(() => {
    // Recalcula el % global de cada curso cuando cambia cualquier progreso o estructura cacheada
    Object.keys(courseStructureCache).forEach(courseId => {
      const struct = courseStructureCache[courseId];
      const map = studentProgress[courseId] || {};
      // map es { [estructura_id]: {...} }, lo convertimos a array para el helper:
      computeAggregateCourseProgress(courseId, struct, Object.values(map));
    });
  }, [studentProgress, courseStructureCache, computeAggregateCourseProgress]);

  const getCourseProgress = useCallback((courseId) => {
    return courseProgressMap?.[courseId] ?? 0;
  }, [courseProgressMap]);

  const resolveStudentCourseByCode = useCallback(async (codigo) => {
    // 1) base desde el service (lista de cursos del estudiante)
    const base = await funcionService.resolveStudentCourseByCode(codigo);
    if (!base) return null;

    // 2) detalles del curso para obtener el umbral (varía de nombre en tu BD)
    let details = {};
    try { details = await funcionService.getCourse(base.id); } catch { }

    const thresholdRaw =
      details?.porcentaje_minimo_examen ??
      details?.porcentaje_minimo_aprobacion ??
      details?.minimo_aprobacion ??
      null;

    const threshold = Number.isFinite(Number(thresholdRaw)) ? Number(thresholdRaw) : 100;

    // 3) progreso global actual (si no lo tenemos, intenta hidratarlo)
    let progress = getCourseProgress ? getCourseProgress(base.id) : 0;

    // Si aún no hay progreso cacheado para este curso, hidrátalo rápido
    if (!progress || progress === 0) {
      try { await getCourseStructureStudent(base.id, true); } catch { }
      progress = getCourseProgress ? getCourseProgress(base.id) : progress;
    }

    // 4) regla de completitud: ya aprobado en backend O cumple umbral de progreso
    const meets = toNum(progress, 0) >= toNum(threshold, 100);
    const completado = base.completado === true || meets;

    // 5) devuelve objeto enriquecido
    return {
      ...base,
      porcentaje_minimo_examen: threshold,
      progreso_global: toNum(progress, 0),
      completado
    };
  }, [getCourseStructureStudent, getCourseProgress]);


  const ensureCourseProgress = useCallback(async (courseId) => {
    // Si ya lo tenemos en memoria, devolverlo
    if (courseProgressMap.hasOwnProperty(courseId)) {
      return courseProgressMap[courseId];
    }
    try {
      // Si hay cache de estructura y progreso, recalcula sin pegarle al backend
      const struct = courseStructureCache[courseId];
      const map = studentProgress[courseId];
      if (struct && map) {
        return computeAggregateCourseProgress(courseId, struct, Object.values(map));
      }

      // Caso normal: trae estructura+progreso y calcula
      const res = await getCourseStructureStudent(courseId, true);
      const progress = computeAggregateCourseProgress(
        courseId,
        res?.structure || [],
        res?.progress || []
      );
      return progress;
    } catch (e) {
      console.error("[ensureCourseProgress] falló para curso", courseId, e);
      return 0;
    }
  }, [
    courseProgressMap,
    courseStructureCache,
    studentProgress,
    computeAggregateCourseProgress,
    getCourseStructureStudent,
  ]);

  const prefetchCoursesProgress = useCallback(async (courseIds, { concurrency = 4 } = {}) => {
    if (!Array.isArray(courseIds) || courseIds.length === 0) return;
    const queue = [...new Set(courseIds.map(Number).filter(Boolean))];
    let idx = 0;
    const workers = Array.from({ length: Math.min(concurrency, queue.length) }, () => (async () => {
      while (idx < queue.length) {
        const id = queue[idx++];
        await ensureCourseProgress(id);
      }
    })());
    await Promise.all(workers);
  }, [ensureCourseProgress]);


  const refreshCourseProgress = async (courseId) => {
    const struct = courseStructureCache[courseId];
    if (!struct) return 0;
    const map = studentProgress[courseId] || {};
    return computeAggregateCourseProgress(courseId, struct, Object.values(map));
  };

  // (opcional) promedio global entre todos los cursos con cache
  const getOverallProgress = () => {
    const vals = Object.values(courseProgressMap || {});
    if (!vals.length) return 0;
    return Math.round(vals.reduce((a, b) => a + toNum(b, 0), 0) / vals.length);
  };

  // === EFECTO PARA CARGAR DATOS INICIALES ===
  useEffect(() => {
    // Cargar tipos permitidos al inicializar el contexto
    loadAllowedContentTypes();
    loadAllStructureTypes();
  }, []);

  // === FUNCIONES PARA GESTIÓN DE PROGRESO ===

  // Obtener progreso del estudiante en un curso
  const getStudentProgress = async (courseId, studentId = null) => {
    try {
      setProgressLoading(true);
      const result = await funcionService.getStudentProgress(courseId, studentId);

      // Actualizar estado local del progreso
      if (result.progress) {
        const progressMap = {};
        result.progress.forEach(p => {
          progressMap[p.estructura_id] = p;
        });
        setStudentProgress(prev => ({
          ...prev,
          [courseId]: progressMap
        }));
      }

      return result;
    } catch (error) {
      console.error('Error obteniendo progreso:', error);
      throw error;
    } finally {
      setProgressLoading(false);
    }
  };

  // Actualizar progreso de elemento
  const updateElementProgress = async (estructuraId, progressData) => {
    try {
      const result = await funcionService.updateElementProgress(estructuraId, progressData);

      // Actualizar estado local si es exitoso
      if (result.success) {
        setStudentProgress(prev => {
          const updated = { ...prev };
          Object.keys(updated).forEach(courseId => {
            if (updated[courseId][estructuraId]) {
              updated[courseId][estructuraId] = {
                ...updated[courseId][estructuraId],
                ...progressData
              };
            }
          });
          return updated;
        });
      }

      return result;
    } catch (error) {
      console.error('Error actualizando progreso:', error);
      throw error;
    }
  };

  // Completar elemento
  const completeElement = async (estructuraId, completionData = {}) => {
    try {
      const result = await funcionService.completeElement(estructuraId, completionData);

      // Actualizar estado local
      if (result.success) {
        setStudentProgress(prev => {
          const updated = { ...prev };
          Object.keys(updated).forEach(courseId => {
            if (updated[courseId][estructuraId]) {
              updated[courseId][estructuraId] = {
                ...updated[courseId][estructuraId],
                completado: true,
                fecha_completado: new Date().toISOString(),
                porcentaje_completado: 100,
                ...completionData
              };
            }
          });
          return updated;
        });

        // Refrescar UTMCoins si se completó algo
        await refreshUTMCoins();
      }

      return result;
    } catch (error) {
      console.error('Error completando elemento:', error);
      throw error;
    }
  };

  // Desbloquear elemento (admin/docente)
  const unlockElement = async (estudianteId, estructuraId) => {
    return await funcionService.unlockElement(estudianteId, estructuraId);
  };

  // Obtener elementos desbloqueados
  const getUnlockedElements = async (courseId, studentId = null) => {
    return await funcionService.getUnlockedElements(courseId, studentId);
  };

  // Reiniciar progreso (admin)
  const resetStudentProgress = async (courseId, studentId) => {
    try {
      const result = await funcionService.resetStudentProgress(courseId, studentId);

      // Limpiar progreso local para este curso
      if (result.success) {
        setStudentProgress(prev => {
          const updated = { ...prev }; delete updated[courseId]; return updated;
        });
        setCourseProgressMap(prev => {
          const updated = { ...prev }; delete updated[courseId]; return updated;
        });
        setCourseStructureCache(prev => {
          const updated = { ...prev }; delete updated[courseId]; return updated;
        });
      }

      return result;
    } catch (error) {
      console.error('Error reiniciando progreso:', error);
      throw error;
    }
  };

  // Obtener estadísticas de progreso de curso
  const getCourseProgressStats = async (courseId) => {
    return await funcionService.getCourseProgressStats(courseId);
  };

  // === FUNCIONES PARA ACTIVIDADES ===

  // Responder pregunta de actividad
  const submitActivityAnswer = async (actividadId, answerData) => {
    try {
      const result = await funcionService.submitActivityAnswer(actividadId, answerData);

      // Si la respuesta fue correcta, actualizar progreso local
      if (result.correcto) {
        // Aquí podrías disparar una actualización del progreso
        // o esperar a que el backend lo maneje automáticamente
      }

      return result;
    } catch (error) {
      console.error('Error enviando respuesta:', error);
      throw error;
    }
  };

  // Obtener preguntas de actividad
  const getActivityQuestions = async (actividadId) => {
    return await funcionService.getActivityQuestions(actividadId);
  };

  // Completar juego de actividad
  const completeActivityGame = async (actividadId, gameData) => {
    try {
      const result = await funcionService.completeActivityGame(actividadId, gameData);

      // Actualizar progreso si el juego se completó exitosamente
      if (result.completado) {
        await refreshUTMCoins();
      }

      return result;
    } catch (error) {
      console.error('Error completando juego:', error);
      throw error;
    }
  };

  // Obtener configuración de juego
  const getActivityGameConfig = async (actividadId) => {
    return await funcionService.getActivityGameConfig(actividadId);
  };

  // === FUNCIONES PARA TESTS ===

  // Obtener tests habilitados
  const getEnabledTests = async (courseId) => {
    return await funcionService.getEnabledTests(courseId);
  };

  // Iniciar test
  const startTestPresentation = async (testId) => {
    return await funcionService.startTestPresentation(testId);
  };

  // Enviar respuestas de test
  const submitTestAnswers = async (presentacionId, answers) => {
    return await funcionService.submitTestAnswers(presentacionId, answers);
  };

  // Obtener resultados de test
  const getTestResults = async (presentacionId) => {
    return await funcionService.getTestResults(presentacionId);
  };

  // === FUNCIONES PARA GAMIFICACIÓN ===

  // Obtener UTMCoins del estudiante
    const getStudentUTMCoins = useCallback(async () => {
    if (utmcoinsInflightRef.current) return utmcoinsInflightRef.current;
    const task = (async () => {
      try {
        const result = await funcionService.getStudentUTMCoins();
        setUTMCoins(result?.utmcoins ?? result ?? null);
        return result;
      } catch (error) {
        console.error('Error obteniendo UTMCoins:', error);
        throw error;
      } finally {
        utmcoinsInflightRef.current = null;
      }
    })();
    utmcoinsInflightRef.current = task;
    return task;
  }, []);

  // Refrescar UTMCoins (función auxiliar)
  const refreshUTMCoins = useCallback(async () => {
    try {
      await getStudentUTMCoins();
    } catch (error) {
      console.error('Error refrescando UTMCoins:', error);
    }
  }, [getStudentUTMCoins]);

  // Obtener historial de UTMCoins
  const getUTMCoinsHistory = async (page = 1, limit = 10) => {
    return await funcionService.getUTMCoinsHistory(page, limit);
  };

  // Obtener racha del estudiante
    const getStudentStreak = useCallback(async () => {
    if (streakInflightRef.current) return streakInflightRef.current;
    const task = (async () => {
      try {
        const result = await funcionService.getStudentStreak();
        setStudentStreak(result?.racha ?? result ?? null);
        return result;
      } catch (error) {
        console.error('Error obteniendo racha:', error);
        throw error;
      } finally {
        streakInflightRef.current = null;
      }
    })();
    streakInflightRef.current = task;
    return task;
  }, []);

  const getGamificationSummary = useCallback(async () => {
    if (gamificationSummaryInflightRef.current) return gamificationSummaryInflightRef.current;
    const task = (async () => {
      try {
        const result = await funcionService.getGamificationSummary();
        setUTMCoins(result?.utmcoins ?? null);
        setStudentStreak(result?.racha ?? null);
        return result;
      } catch (error) {
        console.error('Error obteniendo resumen de gamificaci�n:', error);
        throw error;
      } finally {
        gamificationSummaryInflightRef.current = null;
      }
    })();
    gamificationSummaryInflightRef.current = task;
    return task;
  }, []);
  // Registrar conexión diaria
  const registerDailyConnection = useCallback(async () => {
    try {
      const result = await funcionService.registerDailyConnection();

      // Actualizar racha si cambió
      if (result.racha_actualizada) {
        await getStudentStreak();
      }

      return result;
    } catch (error) {
      console.error('Error registrando conexión:', error);
      throw error;
    }
  }, [getStudentStreak]);

  // === FUNCIONES ADMINISTRATIVAS ===

  // Obtener reporte de progreso
  const getProgressReport = async (courseId, filters = {}) => {
    return await funcionService.getProgressReport(courseId, filters);
  };

  // Exportar datos de progreso
  const exportProgressData = async (courseId, format = 'xlsx') => {
    return await funcionService.exportProgressData(courseId, format);
  };

  // === FUNCIONES DE UTILIDAD ===

  // Verificar si un elemento está completado
  const isElementCompleted = (courseId, estructuraId) => {
    return studentProgress[courseId]?.[estructuraId]?.completado || false;
  };

  // Verificar si un elemento está desbloqueado
  const isElementUnlocked = (courseId, estructuraId) => {
    return studentProgress[courseId]?.[estructuraId]?.desbloqueado || false;
  };

  // Obtener porcentaje de progreso de un elemento
  const getElementProgress = (courseId, estructuraId) => {
    return studentProgress[courseId]?.[estructuraId]?.porcentaje_completado || 0;
  };

  const getElementProgressEntry = (courseId, estructuraId) => {
    return studentProgress[courseId]?.[estructuraId] || null;
  };

  // Obtener progreso de actividades en una tarea
  const getTaskActivityProgress = (courseId, tareaId, actividades = []) => {
    if (!actividades.length) return { completed: 0, total: 0 };

    const completed = actividades.filter(actividad =>
      isElementCompleted(courseId, actividad.id)
    ).length;

    return { completed, total: actividades.length };
  };



  // Limpiar datos de progreso (logout)
  const clearProgressData = () => {
    setStudentProgress({});
    setUTMCoins(null);
    setStudentStreak(null);
    setCourseProgressMap({});
    setCourseStructureCache({});
    setStoreItemsCache([]);
    setStorePurchasesCache([]);
    utmcoinsInflightRef.current = null;
    streakInflightRef.current = null;
    gamificationSummaryInflightRef.current = null;
  };
  const previousUserScopeRef = React.useRef(null);
  // Inicializar datos del estudiante (al hacer login)
    const initializeStudentData = useCallback(async () => {
    try {
      await registerDailyConnection().catch((error) => {
        console.error('Error registrando conexi�n diaria:', error);
      });
      await getGamificationSummary();
    } catch (error) {
      console.error('Error inicializando datos del estudiante:', error);
    }
  }, [getGamificationSummary, registerDailyConnection]);

  // === EXÁMENES ===

  // Estudiante: exámenes visibles (agendado + presentación)
  const fetchStudentExams = async (params = {}) => {
    return await funcionService.fetchStudentExams(params);
  };

  const fetchCourseExams = async (courseId) => {
    return await funcionService.fetchCourseExams(courseId);
  };

  // Obtener examen con preguntas (el backend gatea por presentación/tiempo)
  const getExamWithQuestions = async (examId, params = {}) => {
    return await funcionService.getExamWithQuestions(examId, params);
  };

  // Iniciar examen con código
  const startExam = async (examId, payload) => {
    return await funcionService.startExam(examId, payload);
  };

  // ===== Opcionales para staff =====

  // Staff: crear presentaciones para un horario
  const scheduleExamPresentations = async (examId, payload) => {
    return await funcionService.scheduleExamPresentations(examId, payload);
  };

  // Staff: exámenes del curso con preguntas
  const getCourseExamsWithQuestions = async (cursoId, params = {}) => {
    return await funcionService.getCourseExamsWithQuestions(cursoId, params);
  };

  const reportTaskCompletion = async (payload) => {
    const result = await funcionService.reportTaskCompletion(payload);
    // Si el backend otorgó monedas por 1ra vez en esta tarea, refresca saldo
    if (result?.primera_vez && Number(result?.utmcoins_ganadas) > 0) {
      try { await refreshUTMCoins(); } catch { }
    }
    return result;
  };

  const startTaskAttempt = async (payload) => {
    const result = await funcionService.startTaskAttempt(payload);
    return result;
  };


  const fetchCourseExamSchedules = async (cursoId, opts) => funcionService.fetchCourseExamSchedules(cursoId, opts);
  const fetchMyExamBookings = async (params) => {
    // Incluir automáticamente el user_id del usuario logueado
    const paramsWithUserId = {
      ...params,
      user_id: user?.id // Agregar el ID del usuario autenticado
    };

    return funcionService.fetchMyExamBookings(paramsWithUserId);
  };
  const cancelMyExamBooking = async (bookingId, userID) => funcionService.cancelMyExamBooking(bookingId, userID);
  const setStudentExamEnabled = async (examId, studentId, habilitado, userid) => {
    return await funcionService.setStudentExamEnabled(examId, studentId, habilitado, userid);
  };

  const getTaskSubmission = async (courseId, tareaId) => {
    const data = await funcionService.getTaskSubmission(courseId, tareaId);
    setTaskSubmissions(prev => ({
      ...prev,
      [courseId]: { ...(prev[courseId] || {}), [tareaId]: data }
    }));
    return data;
  };

  const getModuleResources = async (moduloId, filters = {}) => {
    try {
      return await funcionService.getModuleResources(moduloId, filters);
    } catch (error) {
      console.error("Error al obtener recursos del módulo:", error);
      throw error;
    }
  };

  const getCachedTaskSubmission = (courseId, tareaId) =>
    taskSubmissions?.[courseId]?.[tareaId] ?? null;

  const selfScheduleExam = async (horarioId, userId, acceptTerms) => {
    return await funcionService.selfScheduleExam(horarioId, userId, acceptTerms); // 👈
  };

  const fetchExamTermsCurrent = async () => {
    return await funcionService.getExamTermsCurrent();
  };

  const resumeRunningExamAttempt = async (examId, horarioId) => {
    return await funcionService.resumeRunningAttempt(examId, horarioId);
  };

  const finishExam = async (presentacionId, payload) => {
    return await funcionService.finishExam(presentacionId, payload);
  };



  // Guardar progreso del examen
  const saveExamProgress = async (presentacionId, progressData) => {
    const { answers, lockedIds, currentIndex } = progressData;
    return await funcionService.saveExamProgress(presentacionId, {
      answers,
      lockedIds,
      currentIndex
    });
  };


  //============ Ver perfil=========
  const getMyProfileOverview = async (include = "") =>
    await funcionService.getMyProfileOverview(include);

  const getMyProfile = getMyProfileOverview; // alias
  // =========== EXAMS ===========
  const getPresentationQuestions = async (presentacionId) =>
    await funcionService.getPresentationQuestions(presentacionId);

  const finishPresentation = async (presentacionId, respuestasPayloadArray, regrade = false) =>
    await funcionService.finishPresentation(presentacionId, respuestasPayloadArray, regrade);

  const savePresentationProgress = async (presentacionId, respuestasPayloadArray, indice) =>
    await funcionService.savePresentationProgress(presentacionId, respuestasPayloadArray, indice);
  // (opcional, si usas el gate)
  const getLevelTestStatus = async (nivelId) =>
    await funcionService.getLevelTestStatus(nivelId);

  const getLevelTestReview = async (nivelId) =>
    await funcionService.getLevelTestReview(nivelId);

  const startLevelTest = async (testId) =>
    await funcionService.startLevelTest(testId);

  const adminListLevelsWithTests = async (cursoId) =>
    await funcionService.adminListLevelsWithTests(cursoId);

  const adminCreateLevelTest = async (payload) =>
    await funcionService.adminCreateLevelTest(payload);


  const fetchLevelTestQuestions = async (testId, options) =>
    await funcionService.fetchLevelTestQuestions(testId, options);

  const addCustomLevelTestQuestion = async (testId, question) =>
    await funcionService.addCustomLevelTestQuestion(testId, question);

  const updateLevelTestQuestion = async (testId, questionId, question) =>
    await funcionService.updateLevelTestQuestion(testId, questionId, question);

  const deleteLevelTestQuestion = async (testId, questionId) =>
    await funcionService.deleteLevelTestQuestion(testId, questionId);

  const cloneLevelTestQuestion = async (testId, payload) =>
    await funcionService.cloneLevelTestQuestion(testId, payload);

  const adminDeleteLevelTest = async (testId, payload) =>
    await funcionService.adminDeleteLevelTest(testId, payload);

  const adminUpdateLevelTest = async (testId, payload) =>
    await funcionService.adminUpdateLevelTest(testId, payload);

  const adminGetLevelTest = async (id) =>
    await funcionService.adminGetLevelTest(id);

  const deleteExamRef = async (examId, refId) =>
    await funcionService.deleteExamRef(examId, refId);

  const createExamQuestionPool = async (examId, payload) =>
    await funcionService.createExamQuestionPool(examId, payload);

  const fetchExamSchedulesByCourse = async (cursoId, options = {}) =>
    await funcionService.fetchExamSchedulesByCourse(cursoId, options);

  const createLevelTestRef = async (testId, payload) =>
    await funcionService.createLevelTestRef(testId, payload);

  const deleteLevelTestRef = async (testId, refId) =>
    await funcionService.deleteLevelTestRef(testId, refId);

  const getCourseBanks = (cursoId) => funcionService.getCourseBanks(cursoId);
  const createCourseBank = (cursoId, payload) => funcionService.createCourseBank(cursoId, payload);
  const updateCourseBank = (cursoId, bankId, payload) => funcionService.updateCourseBank(cursoId, bankId, payload);
  const deleteCourseBank = (cursoId, bankId) => funcionService.deleteCourseBank(cursoId, bankId);

  // preguntas por banco
  const getBankQuestions = (cursoId, bankId, opts = {}) => funcionService.getBankQuestions(cursoId, bankId, opts);
  const createBankQuestion = (cursoId, bankId, payload) => funcionService.createBankQuestion(cursoId, bankId, payload);
  const updateBankQuestion = (cId, bId, qId, payload) => funcionService.updateBankQuestion(cId, bId, qId, payload);
  const deleteBankQuestion = (cId, bId, qId) => funcionService.deleteBankQuestion(cId, bId, qId);

  // (opcional) compat si alguna vista antigua sigue llamando sin bankId:
  const getCourseBankQuestions = (cursoId, opts, bankId = null) => funcionService.getCourseBankQuestions(cursoId, opts, bankId);

  // Descargar reporte narrativo del nivel (PDF) - estudiante
  const downloadLevelReportPdf = useCallback(async (nivelId) => {
    return funcionService.downloadLevelReportPdf(nivelId);
  }, []);


  // ===== TIENDA: helpers =====
  const fetchStoreItems = useCallback(async (params = {}) => {
    try {
      setStoreLoading(true);
      const data = await funcionService.getStoreItems(params);
      // el backend puede devolver {items} o {products}
      const list = Array.isArray(data?.items) ? data.items : (data?.products || []);
      setStoreItemsCache(list);
      return data;
    } finally {
      setStoreLoading(false);
    }
  }, []);

  const getStoreItem = useCallback(async (itemId) => {
    return funcionService.getStoreItem(itemId);
  }, []);

  // Útil para mostrar “¿te alcanza?” sin comprar todavía
  const previewStorePurchase = useCallback(async ({ itemId, quantity = 1 }) => {
    return funcionService.previewStorePurchase({ item_id: itemId, quantity });
  }, []);

  const buyStoreItem = useCallback(async ({ itemId, quantity = 1 }) => {
    // Compra y refresca saldo de UTMCoins
    const res = await funcionService.buyStoreItem({ item_id: itemId, quantity });
    await refreshUTMCoins();
    // Si el backend devuelve la compra realizada, actualiza cache
    const purchase = res?.purchase || res?.data || res;
    if (purchase) setStorePurchasesCache(prev => [purchase, ...(prev || [])]);
    return res;
  }, [refreshUTMCoins]);

  const getMyStorePurchases = useCallback(async (params = {}) => {
    const data = await funcionService.getMyStorePurchases(params);
    const list = Array.isArray(data?.items) ? data.items : (data?.purchases || []);
    setStorePurchasesCache(list);
    return data;
  }, []);

  const getStorePurchase = useCallback(async (purchaseId) => {
    return funcionService.getStorePurchase(purchaseId);
  }, []);

  const redeemStoreCode = useCallback(async (code) => {
    const res = await funcionService.redeemStoreCode(code);
    // tras canjear, el saldo puede cambiar
    await refreshUTMCoins();
    return res;
  }, [refreshUTMCoins]);

  // Pequeño helper para la UI de tienda
  const canAfford = useCallback((price) => {
    const saldo = Number(utmCoins?.cantidad_actual ?? utmCoins?.balance ?? 0);
    return saldo >= Number(price || 0);
  }, [utmCoins]);

  const initComodinIfAbsent = useCallback(async (componenteId) => {
    const res = await funcionService.initComodinIfAbsent(componenteId);
    // puede que en algún momento los comodines den coins u otra cosa,
    // así que refrescamos monedas por si acaso
    await refreshUTMCoins();
    return res;
  }, [refreshUTMCoins]);


  // En tu useFuncion (o donde definiste estos hooks)
  const getComodinesState = useCallback(async (target) => {
    try {
      const data = await funcionService.getComodinesState(target);

      const comodines = Number.isFinite(data?.comodines_restantes)
        ? Number(data.comodines_restantes)
        : 3;

      const vidas = (data?.vidas_restantes == null)
        ? null
        : Number(data.vidas_restantes);

      return {
        componente_id: Number(data?.componente_id ?? 0) || null,
        comodines_restantes: comodines,
        vidas_restantes: vidas,
        max: Number(data?.max ?? 3),
        sin_ganancias: !!data?.sin_ganancias || comodines <= 0,
        bloqueado_global: !!data?.bloqueado_global,
        _raw: data,
      };
    } catch (e) {
      console.error('getComodinesState failed:', e);
      // Opcional: mostrar toast acorde al code 400/401/500
      throw e;
    }
  }, []);


  const useComodin = useCallback(async (tareaOrNull, opts = {}) => {
    // opts puede traer { kind, componenteId, tareaId }
    const res = await funcionService.useComodin(tareaOrNull, opts);
    // Si más adelante los comodines implican compras/ventas de coins, refrescamos:
    await refreshUTMCoins?.();
    return res; // backend devuelve { componente_id, comodines_restantes, vidas_restantes, ... }
  }, [refreshUTMCoins]);


  // ===========================================================
  // ===============  ADMIN TIENDA (wrappers)  =================
  // ===========================================================
  const adminListStoreItems = useCallback(async ({
    page = 1, limit = 20, search = "", category = "", sort = "popular", activo = ""
  } = {}) => {
    return await funcionService.adminListStoreItems({ page, limit, search, category, sort, activo });
  }, []);

  const adminCreateStoreItem = useCallback(async (payload) => {
    // payload: { nombre, descripcion, categoria, precio_coins, activo, stock_infinito, stock_actual, imagen_url, badge, limit_per_user }
    return await funcionService.adminCreateStoreItem(payload);
  }, []);

  const adminUpdateStoreItem = useCallback(async (itemId, payload) => {
    return await funcionService.adminUpdateStoreItem(itemId, payload);
  }, []);

  const adminDeleteStoreItem = useCallback(async (itemId) => {
    return await funcionService.adminDeleteStoreItem(itemId);
  }, []);

  const adminRestockItem = useCallback(async (itemId, { delta }) => {
    // delta puede ser positivo (sumar) o negativo (restar)
    return await funcionService.adminRestockItem(itemId, { delta });
  }, []);

  const adminToggleItemActive = useCallback(async (itemId, active) => {
    return await funcionService.adminToggleItemActive(itemId, active);
  }, []);

  const claimStudentStreak = useCallback(async () => {
    const data = await funcionService.claimStudentStreak();

    setStudentStreak((prev) => {
      const base = prev?.racha ?? prev ?? {};
      const currentFromResponse = Number(
        data?.current ??
        data?.racha_actual_dias ??
        data?.streak_day_number
      );

      const nextCurrent = Number.isFinite(currentFromResponse)
        ? currentFromResponse
        : Number(base?.current ?? base?.racha_actual_dias ?? 0) + 1;

      return {
        ...base,
        current: nextCurrent,
        racha_actual_dias: nextCurrent,
        claimedToday: true,
        eligibleToday: false,
        lastClaimYMD: data?.lastClaimYMD ?? base?.lastClaimYMD ?? null,
      };
    });

    await Promise.all([getStudentStreak(), refreshUTMCoins()]);
    return data;
  }, [getStudentStreak, refreshUTMCoins]);

  const uploadProctorSnapshot = async (payload) => {
    return await funcionService.uploadProctorSnapshot(payload);
  };

  useEffect(() => {
    const prevScope = previousUserScopeRef.current;
    if (prevScope && prevScope !== userScope) {
      clearProgressData();
    }

    previousUserScopeRef.current = userScope;

    if (user?.id) {
      initializeStudentData();
    } else {
      clearProgressData();
    }
  }, [user?.id, userScope, initializeStudentData]);

  const fetchProctorPresentations = async (params = {}) => {
    return await funcionService.fetchProctorPresentations(params);
  };

  const fetchProctorSnapshots = async (presentacionId) => {
    return await funcionService.fetchProctorSnapshots(presentacionId);
  };

  const reviewProctorPresentation = async (presentacionId, body) => {
    return await funcionService.reviewProctorPresentation(presentacionId, body);
  };

  const fetchProctorStats = async () => {
    return await funcionService.fetchProctorStats();
  };
  // Obtener permisos por rol del curso
  const getCourseRolePermissions = async (courseId) => {
    return await funcionService.getCourseRolePermissions(courseId);
  };

  // Actualizar permisos por rol del curso
  const updateCourseRolePermissions = async (courseId, payload) => {
    return await funcionService.updateCourseRolePermissions(courseId, payload);
  };

  const getMyCoursePermissions = async (courseId) => {
    return await funcionService.getMyCoursePermissions(courseId);
  };

  // ===========================================================

  const getTimeNow = useCallback(() => {
    // no hace falta async/await aquí, puedes devolver la promesa
    return funcionService.getTimeNow();
  }, []); // 👈 se mantiene estable entre renders

  // ========== TÉRMINOS Y CONDICIONES ==========

  const acceptPlatformTerms = useCallback(async (clientInfo = {}) => {
    if (!user?.id) {
      throw new Error('Usuario no autenticado');
    }

    try {
      const result = await funcionService.acceptPlatformTerms({
        usuario_id: user.id,
        clientInfo: {
          ip: clientInfo.ip || null,
          ua: clientInfo.ua || clientInfo.userAgent || navigator?.userAgent || null,
        },
      });


      return result;
    } catch (error) {
      console.error('❌ Error aceptando términos:', error);
      throw error;
    }
  }, [user?.id]);

  const checkPlatformTermsAcceptance = useCallback(async () => {
    if (!user?.id) {
      throw new Error('Usuario no autenticado');
    }

    try {
      const result = await funcionService.checkPlatformTermsAcceptance(user.id);
      return result;
    } catch (error) {
      console.error('❌ Error verificando términos:', error);
      throw error;
    }
  }, [user?.id]);

  const fetchRegistrationTerms = async () => {
    return await funcionService.fetchRegistrationTerms();
  };

  // GET /api/facultades/:id/admins
  const getFacultyAdmins = useCallback(async (facultadId, params) => {
    return await funcionService.getFacultyAdmins(facultadId, params);
  }, []);

  // POST /api/facultades/:id/admins
  const addFacultyAdmin = useCallback(async (facultadId, payload) => {
    return await funcionService.addFacultyAdmin(facultadId, payload);
  }, []);

  // PUT /api/facultades/admins/:relId
  const updateFacultyAdmin = useCallback(async (relId, payload) => {
    return await funcionService.updateFacultyAdmin(relId, payload);
  }, []);

  // DELETE /api/facultades/admins/:relId
  const removeFacultyAdmin = useCallback(async (relId) => {
    return await funcionService.removeFacultyAdmin(relId);
  }, []);

  // Lookup usuarios (modal agregar admin)
  const searchUsers = useCallback(async (params) => {
    return await funcionService.searchUsersForFacultyAdmin(params);
  }, []);

  useEffect(() => {
    syncEcuadorTimeWith(getTimeNow).catch(() => { });
  }, [getTimeNow]);

  // Términos del examen
  const fetchExamTerms = useCallback(async (horarioId) => {
    return await funcionService.fetchExamTerms(horarioId);
  }, []);

  const acceptExamTerms = useCallback(async (horarioId) => {
    return await funcionService.acceptExamTerms(horarioId);
  }, []);

  const fetchProctoringDashboard = async (horarioId) => {
    return await funcionService.fetchProctoringDashboard(horarioId);
  };

  const createProctoringNovedad = async (horarioId, payload) => {
    return await funcionService.createProctoringNovedad(horarioId, payload);
  };

  const updateProctoringNovedad = async (horarioId, novedadId, payload) => {
    return await funcionService.updateProctoringNovedad(horarioId, novedadId, payload);
  };

  const fetchExamScheduleStudents = async (horarioId) => {
    return await funcionService.fetchExamScheduleStudents(horarioId);
  };

  const fetchAvailableStudentsForExamSchedule = async (horarioId, params) => {
    return await funcionService.fetchAvailableStudentsForExamSchedule(horarioId, params);
  };

  const addStudentToExamSchedule = async (horarioId, estudianteId) => {
    return await funcionService.addStudentToExamSchedule(horarioId, estudianteId);
  };

  const removeStudentFromExamSchedule = async (horarioId, estudianteId) => {
    return await funcionService.removeStudentFromExamSchedule(horarioId, estudianteId);
  };

  const validateExamAccessCode = async (examId, payload) => {
    return await funcionService.validateExamAccessCode(examId, payload);
  };

  const fetchProctoringReviewQueue = async (horarioId, params) => {
    return await funcionService.fetchProctoringReviewQueue(horarioId, params);
  };

  const reviewProctoringPresentation = async (presentacionId, payload) => {
    return await funcionService.reviewProctoringPresentation(
      presentacionId,
      payload
    );
  };

  const downloadProctoringReportsZip = async (horarioId) => {
    return await funcionService.downloadProctoringReportsZip(horarioId);
  };

  const fetchProctoringStudentReport = async (presentacionId) => {
    return await funcionService.fetchProctoringStudentReport(presentacionId);
  };

  return (
    <FuncionContext.Provider value={{
      fetchProctoringReviewQueue,
      reviewProctoringPresentation,
      validateExamAccessCode,
      fetchExamScheduleStudents,
      fetchAvailableStudentsForExamSchedule,
      addStudentToExamSchedule,
      removeStudentFromExamSchedule,
      fetchProctoringDashboard,
      createProctoringNovedad,
      updateProctoringNovedad,
      fetchExamTerms,
      acceptExamTerms,
      getFacultyAdmins,
      addFacultyAdmin,
      updateFacultyAdmin,
      removeFacultyAdmin,
      searchUsers,
      fetchRegistrationTerms,
      getMyCoursePermissions,
      getCourseRolePermissions,
      updateCourseRolePermissions,
      getTimeNow,
      acceptPlatformTerms,
      checkPlatformTermsAcceptance,
      fetchProctorPresentations,
      fetchProctorSnapshots,
      fetchProctoringStudentReport,
      downloadProctoringReportsZip,
      reviewProctorPresentation,
      fetchProctorStats,
      // ===== TIENDA (admin) =====
      claimStudentStreak,
      uploadProctorSnapshot,
      adminListStoreItems,
      adminCreateStoreItem,
      adminUpdateStoreItem,
      adminDeleteStoreItem,
      adminRestockItem,
      adminToggleItemActive,
      // ===== TIENDA =====
      useComodin,
      getComodinesState,
      initComodinIfAbsent,
      fetchStoreItems,
      getStoreItem,
      previewStorePurchase,
      buyStoreItem,
      getMyStorePurchases,
      getStorePurchase,
      redeemStoreCode,
      canAfford,
      storeItemsCache,
      storePurchasesCache,
      storeLoading,
      getCourseBanks, createCourseBank, updateCourseBank, deleteCourseBank, getBankQuestions,
      getCourseBankQuestions,
      createBankQuestion,
      updateBankQuestion,
      deleteBankQuestion,
      toNum,
      courseProgressMap,
      getCourseProgress,
      refreshCourseProgress,
      ensureCourseProgress,
      prefetchCoursesProgress,
      getOverallProgress,
      deleteLevelTestRef,
      createLevelTestRef,
      fetchExamSchedulesByCourse,
      createExamQuestionPool,
      deleteExamRef,
      adminUpdateLevelTest,
      adminDeleteLevelTest,
      adminGetLevelTest,

      fetchLevelTestQuestions,
      addCustomLevelTestQuestion,
      updateLevelTestQuestion,
      deleteLevelTestQuestion,
      cloneLevelTestQuestion,
      adminListLevelsWithTests,
      adminCreateLevelTest,

      finishPresentation,
      getPresentationQuestions,
      savePresentationProgress,
      // === NUEVOS ===
      getLevelTestStatus,
      getLevelTestReview,
      startLevelTest,

      // Verperfil
      getMyProfile,
      getMyProfileOverview,


      saveExamProgress,
      resumeRunningExamAttempt,
      getModuleResources,
      fetchCourseExams,
      finishExam,
      // Funciones existentes
      fetchFacultades,
      createFacultad,
      updateFacultad,
      deleteFacultad,
      fetchCourses,
      fetchStudentCourses,
      fetchTeacherCourses,
      getCourse,
      createCourse,
      updateCourse,
      deleteCourse,
      getCourseStudents,
      assignTeacherToCourse,
      getCourseLevels,


      // Nuevas funciones para admin
      fetchDashboardStats,
      fetchUsers,
      getUser,
      fetchUserStats,
      fetchStudents,
      findUserForImport,
      fetchTeachers,
      fetchCourseStats,
      fetchRecentActivity,
      fetchRecentRegistrations,
      createUser,
      updateUser,
      deleteUser,
      changeUserRole,
      toggleUserStatus,
      fetchSystemReports,
      generateReport,
      addUserRole,
      removeUserRole,
      getUserRoles,

      // Funciones para docentes
      updateTeacherAssignment,
      removeTeacherFromCourse,
      getTeacherCourses,

      // Funciones para estudiantes
      enrollStudentToCourse,
      updateStudentEnrollment,
      removeStudentFromCourse,
      getStudentCourses,

      // Funciones para horarios de examen
      fetchExamSchedules,
      fetchExamStats,
      createExamSchedule,
      fetchExamAssistantOptions,
      updateExamSchedule,
      deleteExamSchedule,
      // === Exámenes ===
      fetchExams,
      createExam,
      updateExam,
      deleteExam,
      fetchCourseExamSchedules,
      selfScheduleExam,
      fetchMyExamBookings,
      cancelMyExamBooking,
      resolveStudentCourseByCode,
      fetchExamTermsCurrent,

      // === Preguntas de examen ===
      fetchExamQuestions,
      addCustomExamQuestion,
      cloneExamQuestion,
      deleteExamQuestion,
      updateExamQuestion,
      browseStructureQuestions,
      browseStructureMeta,
      browseGameItemQuestions,

      // Funciones para estudiantes en exámenes
      fetchExamStudents,
      fetchAvailableStudents,
      addStudentToExam,
      removeStudentFromExam,
      updateStudentExamStatus,
      // Funciones
      loadAllowedContentTypes,
      loadAllStructureTypes,
      updateAllowedContentTypes,
      validateContentTypesConfiguration,
      canHaveContent,
      getStructureTypeInfo,
      updateSystemConfiguration,
      getSystemConfigurations,

      // Funciones de utilidad
      isContentTypeAllowed: canHaveContent, // Alias más claro
      getCourseStructureStudent,
      getCourseStructureAdminPreview,

      // Funciones de progreso
      getStudentProgress,
      updateElementProgress,
      completeElement,
      unlockElement,
      getUnlockedElements,
      resetStudentProgress,
      getCourseProgressStats,

      // Funciones de actividades
      submitActivityAnswer,
      getActivityQuestions,
      completeActivityGame,
      getActivityGameConfig,

      // Funciones de tests
      getEnabledTests,
      startTestPresentation,
      submitTestAnswers,
      getTestResults,

      // Funciones de gamificación
      getStudentUTMCoins,
      refreshUTMCoins,
      getUTMCoinsHistory,
      getStudentStreak,
      downloadLevelReportPdf,
      registerDailyConnection,

      // Funciones administrativas
      getProgressReport,
      exportProgressData,

      // Funciones de utilidad
      isElementCompleted,
      isElementUnlocked,
      getElementProgress,
      getElementProgressEntry,
      getTaskActivityProgress,
      clearProgressData,
      initializeStudentData,
      // Estados
      studentProgress,
      utmCoins,
      studentStreak,
      progressLoading,
      //respuesta actividad
      reportTaskCompletion,
      startTaskAttempt,
      // === EXÁMENES ===
      fetchStudentExams,
      getExamWithQuestions,
      startExam,

      // Opcionales staff:
      scheduleExamPresentations,
      getCourseExamsWithQuestions,
      setStudentExamEnabled,
      getTaskSubmission,
      getCachedTaskSubmission,
      taskSubmissions,

    }}>
      {children}
    </FuncionContext.Provider>
  );
};

export const useFuncion = () => useContext(FuncionContext);








